import { DEFAULT_MARKET, marketSchema, type Market } from "@ferrivia/api-contract";

export function parseMarket(value: string | undefined): Market {
  return marketSchema.parse(value ?? DEFAULT_MARKET);
}

export const MARKET: Market = parseMarket(import.meta.env.VITE_MARKET);
